// extracted by mini-css-extract-plugin
export default {"speciesName":"speciesName__VepSpeciesName__nixc5"};